
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import TabArea from "./TabArea";

function TabPanel(props) {
    return (
        <div className="App">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                {
                    props.qscQuestionAreas.map((area, index) => {
                        return <Box key={index}>
                            {props.qscQuestionAreas.length > 1 && <Typography key={index} sx={{ fontWeight: 'bold', marginLeft: 4 }}>{area.questionArea}</Typography>}
                            <TabArea questions={area.qscQuestions} />
                        </Box>
                    })
                }
            </Box>
        </div>
    )
}

export default TabPanel
